import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener, Inject, Injector, INJECTOR,
  Input, OnInit, ViewChild
} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from "@angular/forms";
import {IIntSelectPayload} from "../../../types";
import {IntPortalSlotComponent} from "../../../modules";

@Component({
  selector: 'int-multi-tag-select',
  templateUrl: './int-multi-tag-select.component.html',
  styleUrls: ['vars.scss', './int-multi-tag-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: IntMultiTagSelectComponent,
      multi: true
    }
  ]
})
export class IntMultiTagSelectComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  open$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  active$ = new BehaviorSubject(false);
  selectedList$ = new BehaviorSubject<Array<string>>([]);

  control: NgControl | null = null;

  list$: BehaviorSubject<Array<IIntSelectPayload>> = new BehaviorSubject<Array<IIntSelectPayload>>([]);
  fullList$: BehaviorSubject<Array<IIntSelectPayload>> = new BehaviorSubject<Array<IIntSelectPayload>>([]);

  @Input() label = '';
  @Input() set list (values: Array<IIntSelectPayload>) {
    this.list$.next(values);
    this.fullList$.next(values);
  };
  @Input() dropdownHeight = '12rem';
  @Input() maxDropDownHeight = '10rem';
  @Input() dropDownPaddings = '1rem';
  @Input() dropAreaID: string | number | null = null;

  @ViewChild(IntPortalSlotComponent) private readonly slot!: IntPortalSlotComponent

  constructor(
    private readonly cdr: ChangeDetectorRef,
    @Inject(INJECTOR) readonly injector: Injector,
  ) {}

  ngOnInit() {
    this.control = this.injector.get(NgControl);
  }

  ngAfterViewInit() {
    //this.clickOutsideService.isNotExcludeElements()
  }

  get isError() {
    return this.control !== null ? Boolean(this.control?.invalid) : false;
  }

  get isOpen() {
   return this.open$.value;
  }

  get isActive() {
    return this.active$.value || !this.isTagsListEmpty;
  }

  get selectedList() {
    return this.selectedList$.value;
  }

  get isTagsListEmpty() {
    return this.selectedList.length === 0;
  }

  get isListEmpty() {
    return (this.list$.value || []).length === 0;
  }

  writeValue(list: Array<string> | null) {
    this.selectedList$.next(list || []);
    this.active$.next(!this.isTagsListEmpty);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onTouched() {}

  onChange(data: Array<string>) {}

  deleteTag(value: string, event?: Event) {
    event?.stopPropagation();
    const _data = this.selectedList$.value.filter((_value) => {
      return value !== _value;
    });
    this.setData(_data);
  }

  onItemClick(data: IIntSelectPayload) {
    const {value} = data;
    if(this.isInclude(value)) {
      this.deleteTag(value);
    }else{
      const _data = [...this.selectedList$.value, value];
      this.setData(_data);
    }
  }

  isInclude(value: string) {
    return this.selectedList$.value.includes(value)
  }

  setData(list: Array<string>) {
    this.selectedList$.next(list);
    this.onChange(list);
    setTimeout(() => {
      this.slot?.updateCoords();
    }, 0)

  }

  getTagLabelByValue(value: string): string {
    if(this.isListEmpty) {
      return value;
    }
    const _tagData = this.list$.value.find((item) => {
      return `${item.value}` === `${value}`;
    });

    if(_tagData) {
      return _tagData.label;
    }

    return value;
  }

  @HostListener('click')
  onClick() {
    if(this.open$.value) {
      return;
    }
    this.open$.next(true);
    this.active$.next(true);
  }

  onClose() {
    this.open$.next(false);
    this.active$.next(false);
  }

  onBlur() {
    //this.onClose();
  }

  onToggle(event: Event) {
    event.stopPropagation();
    this.open$.next(!this.open$.value);
    this.active$.next(!this.active$.value);
  }

  repaint() {
    console.log('repaint')
  }

  onSelect(handler: (payload: any, index: number) => void, itemData: any, index: number) {
    handler(itemData, index);
  }
}
